import React, { useState } from "react";
import { Link } from "react-router-dom";
import language from "../../../libraries/label-lang";
import CircularProgress from "@material-ui/core/CircularProgress";
import { connect } from "react-redux";
import _ from "lodash";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import TablePaginationActions from "../../presentational/table-pagination-actions";
import { Selector, CustomDateRange } from "../styling";
import useFetch from "../../../hooks/useFetch";
import moment from "moment/moment";

const mapStateToProps = (state) => {
  return {
    toggle_set_lang: state.toggle_set_lang,
  };
};

export default connect(mapStateToProps)((props) => {
  const isIndo = props.toggle_set_lang === "indo"
  const LANG = props.toggle_set_lang === "indo" ? language.id : language.en;

  const [state, setState] = useState({
    warehouse_id: null,
    ordered_by: null,
    sorted_by: null,
    status: null,
    start_date: null,
    end_date: null,
    page: 1,
    pageIn: 0,
  });

  const params = new URLSearchParams(_.pickBy(state), _.isNull).toString();
  const url = `/inventories?${params}`;
  const { data, isLoading } = useFetch(url);
  const warehouse_data = useFetch("/warehouses");

  const orderedBy = (val) => {
    if (state.sorted_by === null) {
      setState({ ...state, ordered_by: val, sorted_by: 'ASC' })
    } else {
      if (state.sorted_by === 'ASC') {
        setState({ ...state, ordered_by: val, sorted_by: 'DESC' })
      } else {
        setState({ ...state, ordered_by: val, sorted_by: 'ASC' })
      }

    }
  }

  const formatStorage = (name) => {
    if (name === 'Frozen') {
      return 'Beku';
    } else if (name === 'Chilled') {
      return 'Dingin';
    } else if (name === 'Dry') {
      return 'Kering';
    }
  };

  return (
    //   todo ganti responsive 1920
    <div className="dashboard-detail" style={{}}>
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/">{LANG.label_dashboard}</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {LANG.label_assets}
          </li>
        </ol>
      </nav>
      <div className="d-inline-flex justify-content-between w-100 mb-2">
        <h2 className="text-uppercase ">{LANG.label_assets}</h2>
      </div>

      <div className="d-inline-flex justify-content-between w-100">
        <Selector
          vertical
          className="w-100"
          title="Gudang Penyimpanan"
          selected={(x) => setState({ ...state, warehouse_id: x })}
          item={warehouse_data.data}
        />

        {/*<MultipleSelect*/}
        <Selector
          title="Status"
          vertical
          // onChange={(x) => setState({ ...state, status: x },()=>{console.log(x)})}
          // selected={(x) => setState({ ...state, status: x },()=>{console.log(x)})}
          selected={(x) => setState({ ...state, status: x })}
          // displayValue="text"
          // data={[
          item={[
            {
              name: "Akan Datang",
              id: "reserved",
            },
            {
              name: "Diterima",
              id: "received",
            },
            {
              name: "Tersimpan",
              id: "stored",
            },
            {
              name: "Ditolak",
              id: "rejected",
            },
              {
                  name: "Sedang Dikemas",
                  id: "packed",
              },
              {
                  name: "Sedang Dikemas",
                  id: "packing",
              },
              {
                  name: "Sudah Diambil",
                  id: "picked up",
              },
              {
                  name: "Dipesan",
                  id: "ordered",
              },
              {
                  name: "Batal",
                  id: "canceled",
              },
              {
                  name: "Dalam Perjalanan",
                  id: "in transit",
              },
          ]}
        />

        <CustomDateRange
          title="Tanggal Diterima"
          vertical
          onChange={(x, j) => {
            setState({
              ...state,
              start_date: x,
              end_date: j,
            });
          }}
          value={[state.startDate, state.endDate]}
        />
      </div>

      {!_.isEmpty(data) && (
        <div className="table-responsive mt-3">
          <Table className="table-list" size="small">
            <TableHead style={{ whiteSpace: "nowrap" }}>
              <TableRow>
                <TableCell onClick={() => orderedBy('iku_id')}>Kode IKU
                      {state.sorted_by === null ? (
                    ''
                  ) : (state.sorted_by === 'ASC' ? <i className='fas fa-sort-down'> </i> :
                    <i className='fas fa-sort-up'> </i>
                    )
                  }
                </TableCell>

                <TableCell onClick={() => orderedBy('sku_number')}>Kode SKU Tenant
                    {state.sorted_by === null ? (
                    ''
                  ) : (state.sorted_by === 'ASC' ? <i className='fas fa-sort-down'> </i> :
                    <i className='fas fa-sort-up'> </i>
                    )
                  }</TableCell>
                <TableCell onClick={() => orderedBy('name')}>Nama Produk
                    {state.sorted_by === null ? (
                    ''
                  ) : (state.sorted_by === 'ASC' ? <i className='fas fa-sort-down'> </i> :
                    <i className='fas fa-sort-up'> </i>
                    )
                  }
                </TableCell>
                <TableCell onClick={() => orderedBy('length')}>Ukuran Produk
                    {state.sorted_by === null ? (
                    ''
                  ) : (state.sorted_by === 'ASC' ? <i className='fas fa-sort-down'> </i> :
                    <i className='fas fa-sort-up'> </i>
                    )
                  }
                </TableCell>
                <TableCell onClick={() => orderedBy('date_received')}>Tgl. Diterima
                    {state.sorted_by === null ? (
                    ''
                  ) : (state.sorted_by === 'ASC' ? <i className='fas fa-sort-down'> </i> :
                    <i className='fas fa-sort-up'> </i>
                    )
                  }
                </TableCell>
                <TableCell onClick={() => orderedBy('date_expired')}>Sisa Umur Simpan
                    {state.sorted_by === null ? (
                    ''
                  ) : (state.sorted_by === 'ASC' ? <i className='fas fa-sort-down'> </i> :
                    <i className='fas fa-sort-up'> </i>
                    )
                  }
                </TableCell>
                <TableCell onClick={() => orderedBy('city')}>Gudang Penyimpanan
                    {state.sorted_by === null ? (
                    ''
                  ) : (state.sorted_by === 'ASC' ? <i className='fas fa-sort-down'> </i> :
                    <i className='fas fa-sort-up'> </i>
                    )
                  }
                </TableCell>
                <TableCell onClick={() => orderedBy('storage')}>Area
                    {state.sorted_by === null ? (
                    ''
                  ) : (state.sorted_by === 'ASC' ? <i className='fas fa-sort-down'> </i> :
                    <i className='fas fa-sort-up'> </i>
                    )
                  }
                </TableCell>
                <TableCell onClick={() => orderedBy('type_rack')}>Ukuran Loker
                    {state.sorted_by === null ? (
                    ''
                  ) : (state.sorted_by === 'ASC' ? <i className='fas fa-sort-down'> </i> :
                    <i className='fas fa-sort-up'> </i>
                    )
                  }
                </TableCell>
                <TableCell onClick={() => orderedBy('number_rack')}>No. Rak
                    {state.sorted_by === null ? (
                    ''
                  ) : (state.sorted_by === 'ASC' ? <i className='fas fa-sort-down'> </i> :
                    <i className='fas fa-sort-up'> </i>
                    )
                  }
                </TableCell>
                <TableCell onClick={() => orderedBy('number_locker')}>No. Loker
                    {state.sorted_by === null ? (
                    ''
                  ) : (state.sorted_by === 'ASC' ? <i className='fas fa-sort-down'> </i> :
                    <i className='fas fa-sort-up'> </i>
                    )
                  }
                </TableCell>
                <TableCell onClick={() => orderedBy('status')}>Status
                    {state.sorted_by === null ? (
                    ''
                  ) : (state.sorted_by === 'ASC' ? <i className='fas fa-sort-down'> </i> :
                    <i className='fas fa-sort-up'> </i>
                    )
                  }
                </TableCell>
                {/*<TableCell>Permintaan Pemusnahan</TableCell>*/}
              </TableRow>
            </TableHead>
            <TableBody>
              {
                data.data.length === 0 ? (
                  <TableRow style={{ height: 33 * state.perPage }}>
                    <TableCell colSpan={12} style={{ textAlign: 'center', 'height': '330px' }}>{LANG.label_no}</TableCell>
                  </TableRow>
                ) : (
                    data.data.map((item, i) => (
                      <TableRow key={i}>
                        <TableCell>{item.iku_id}</TableCell>
                        <TableCell>SKU- {item.sku_number}</TableCell>
                        <TableCell style={{ minWidth: 200 }}>{item.name}</TableCell>
                        <TableCell>{item.length} x {item.width} x {item.height}</TableCell>
                        <TableCell>{item.date_received ? item.date_received : '-'}</TableCell>
                        <TableCell>{item.date_expired ? moment(item.date_expired).diff(moment.now(), 'days') : '-'}</TableCell>
                        <TableCell>{item.city}</TableCell>
                        <TableCell>{formatStorage(item.storage)}</TableCell>
                        <TableCell>{item.type_rack} - {item.size_rack}</TableCell>
                        <TableCell>{item.number_rack}</TableCell>
                        <TableCell>{item.number_locker}</TableCell>
                        {/*<TableCell>{item.ikus_status}</TableCell>*/}
                        {/*<TableCell>{item.status}</TableCell>*/}
                        <TableCell>{coverName(item.status, !!isIndo)}</TableCell>
                        {/*<TableCell>{}</TableCell>*/}
                      </TableRow>
                    )
                    ))}
            </TableBody>
          </Table>
        </div>
      )}

      {isLoading && (
        <div className="d-inline-flex justify-content-center align-items-center w-100 p-3">
          <CircularProgress />
        </div>
      )}

      {!_.isEmpty(data) && (
        <TablePagination
          rowsPerPageOptions={[10]}
          component="div"
          count={Number(data.total)}
          rowsPerPage={Number(data.per_page)}
          page={Number(state.pageIn)}
          backIconButtonProps={{
            "aria-label": "previous page",
          }}
          nextIconButtonProps={{
            "aria-label": "next page",
          }}
          onChangePage={(e, newPage) => {
            setState({ ...state, page: newPage + 1, pageIn: newPage });
          }}
          // onChangeRowsPerPage={this.handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
        />
      )}
    </div>
  );
});

export const coverName = (status, bahasa) => {
  if (!bahasa) return status

  switch (status.toLowerCase()) {
    case 'reserved': return 'Akan Datang'
    case 'received': return 'Diterima'

    case 'stored': return 'Tersimpan'
    case 'rejected': return 'Ditolak'
    case 'packed': return 'Sedang Dikemas'
    case 'packing': return 'Sedang Dikemas'
    case 'picked up': return 'Sudah Diambil'
    case 'ordered': return 'Dipesan'
    case 'canceled': return 'Batal'
    case 'disposal request': return 'Permintaan Pemusnahan'
    case 'disposed': return 'Sudah Dimusnahkan'
    case 'in transit': return 'Dalam Perjalanan'
    default: return status
  }
}


